import { render, staticRenderFns } from "./MedicineClient.vue?vue&type=template&id=29112bbd&scoped=true"
import script from "./MedicineClient.js?vue&type=script&lang=js&external"
export * from "./MedicineClient.js?vue&type=script&lang=js&external"
import style0 from "./MedicineClient.vue?vue&type=style&index=0&id=29112bbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29112bbd",
  null
  
)

export default component.exports